import React, { FC, useCallback } from 'react';
import { Cascader, Form } from 'antd';
import type { CascaderProps } from 'antd';
import { FormItemProps } from 'antd/lib/form';
import { useField, FieldHookConfig } from 'formik';

export type CascaderFieldProps = FieldHookConfig<any> & {
  item?: FormItemProps;
  input?: CascaderProps;
};

const showSearch = {
  filter: (filterValue: string, options: any[]) => !!options.find((option) => option.label?.toLowerCase?.().includes(filterValue?.toLowerCase?.())),
};

export const CascaderField: FC<CascaderFieldProps> = ({ item, input, ...props }) => {
  const [{ onChange: baseOnChange, onBlur: baseOnBlur, ...field }, meta] = useField(props);

  const onChange = useCallback(
    (value: any) => {
      baseOnChange({ target: { name: field.name, value } } as any);
    },
    [baseOnChange, field.name],
  );

  return (
    <Form.Item {...item} validateStatus={meta.touched && !!meta.error ? 'error' : undefined} help={meta.touched ? meta.error : undefined}>
      <Cascader allowClear showSearch={showSearch} style={{ width: '100%' }} {...field} {...(input as any)} value={field.value || undefined} onChange={onChange} />
    </Form.Item>
  );
};
